// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbLink":"breadcrumbs_breadcrumbLink__blF4A","separator":"breadcrumbs_separator__2PnJH","activePage":"breadcrumbs_activePage__KPVrF"};